module.exports = __webpack_public_path__ + "img/close-order.7dfbf2dc.svg";